import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-set-unread-button',
  templateUrl: './set-unread-button.component.html',
  styleUrls: ['./set-unread-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class SetUnreadButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
